export enum DATE_FORMATS {
  DD_MM_YYYY = 'dd/MM/yyyy',
  TOPUP_ORDER_DATE = 'yyyy-MM-dd HH:mm:ss',
  ISO_8601 = 'YYYY-MM-DD[T]HH:mm:ssZZ',
}
